import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { User } from '@app/_models';

@Component({
  selector: 'app-hero-employee-dashboard',
  templateUrl: './hero-employee-dashboard.component.html',
  styleUrls: ['./hero-employee-dashboard.component.scss'],
  standalone: true,
  imports: [CommonModule, RouterModule]
})
export class HeroEmployeeDashboardComponent {
  @Input() user: User;

  quickActions = [
    {
      title: 'Product Master',
      icon: 'fa-cube',
      route: '/product-master',
      color: '#3F51B5',
      description: 'View and manage product plans'
    },
    {
      title: 'Net Benefit Report',
      icon: 'fa-bar-chart',
      route: '/reports/heroNetBenefitReport',
      color: '#4CAF50',
      description: 'Hero Ensure net benefit analysis'
    }
  ];
}
